import { Text, Stack, Heading, Box } from 'braid-design-system';

import type { ListingProduct } from 'src/generated/graphql';

import { PaymentSuccessCta } from './components/PaymentSuccessCTA';
import { PaymentSuccessLayout } from './components/PaymentSuccessContainer';

interface StandardPaymentSuccessProps {
  standardProduct: ListingProduct;
}

export const StandardPaymentSuccess = (props: StandardPaymentSuccessProps) => (
  <Box data={{ testid: 'standard-payment-success' }}>
    <PaymentSuccessLayout
      callToAction={<PaymentSuccessCta>Create an ad</PaymentSuccessCta>}
    >
      <Stack space="large">
        <Heading level="3" component="h1">
          Purchase success!
        </Heading>

        <Text>You bought a {props.standardProduct.description}.</Text>

        <Text>Now let&#39;s create an ad.</Text>
      </Stack>
    </PaymentSuccessLayout>
  </Box>
);
